<template>
  <div class="content-wrapper">
    <div class="flex mb-4">
      <div class="lg:w-full w-full bg-grid-color h-12">
        <vs-card class="px-5 py-5">
          <div class="card-content">
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Company Name</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-select
                  name="company"
                  v-model="form.company_id"
                  v-validate="'required'"
                >
                  <vs-select-item
                    v-for="(item, index) in companyList"
                    :key="index"
                    :value="item.value"
                    :text="item.text"
                  />
                </vs-select>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('company')"
                  >{{ errors.first("company") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Booth Slug</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="slug"
                  class="w-full"
                  v-model="form.slug"
                />
                <span class="text-danger text-sm" v-show="errors.has('slug')">{{
                  errors.first("slug")
                }}</span>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Booth Design</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'required'"
                  name="design"
                  class="w-full"
                  v-model="form.booth_design"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('design')"
                  >{{ errors.first("design") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Filter</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-select class="selectExample" v-model="form.booth_filter">
                  <vs-select-item
                    :key="index"
                    :value="item.filter_id"
                    :text="item.filter_name"
                    v-for="(item, index) in filterList"
                  />
                </vs-select>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('filter')"
                  >{{ errors.first("filter") }}</span
                >
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Listing Status</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio
                      vs-name="listing_status"
                      v-model="form.listing_status"
                      :vs-value="true"
                      >Active</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      vs-name="listing_status"
                      v-model="form.listing_status"
                      :vs-value="false"
                      >Inactive</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Publish Status</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <ul class="demo-alignment">
                  <li>
                    <vs-radio
                      vs-name="publish_status"
                      v-model="form.publish_status"
                      :vs-value="true"
                      >Active</vs-radio
                    >
                  </li>
                  <li>
                    <vs-radio
                      vs-name="publish_status"
                      v-model="form.publish_status"
                      :vs-value="false"
                      >Inactive</vs-radio
                    >
                  </li>
                </ul>
              </div>
            </div>

            <div class="vx-row mb-6">
              <div class="vx-col sm:w-1/3 w-full">
                <span>Weight</span>
              </div>
              <div class="vx-col sm:w-2/3 w-full">
                <vs-input
                  v-validate="'decimal:4'"
                  name="weight"
                  class="w-full"
                  v-model="form.weight"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('weight')"
                  >{{ errors.first("weight") }}</span
                >
              </div>
            </div>
          </div>
          <div class="vx-row pt-5">
            <div class="vx-col sm:w-2/3 w-full ml-auto">
              <vs-button
                :disabled="!valid"
                class="mr-3 mb-2"
                @click.prevent="validateForm"
                >Create</vs-button
              >
            </div>
          </div>
        </vs-card>
      </div>
    </div>
  </div>
</template>
<script>
import { Validator } from "vee-validate";

import Service from "@/services";

import moment from "moment";
import { mapState } from "vuex";
import { timezones } from "@/utils/Timezones";
import { currencyList } from "@/utils/Constants";

export default {
  components: {},
  data: () => ({
    timezones: timezones,
    valid: true,
    form: {
      attendee_id: null,
      ticket: null,
      company_id: null,
      booth_filter: null,
      booth_design: null,
      slug: null,
      booth_featured_img: null,
      publish_status: true,
      listing_status: true,
      weight: 100,
      booth_remark: null,
    },
    companyList: [],
    filterList: [],
  }),
  created() {
    setTimeout(() => {
      this.loadFilter();
      this.loadCompanies();
    }, 1500);
  },
  methods: {
    loadCompanies() {
      let filterData = {
        e: this.$route.query.e,
        currentPage: 1,
        perPage: 50,
      };

      let params = Object.keys(filterData)
        .map((key) => key + "=" + filterData[key])
        .join("&");

      Service.Company.gets(params).then((res) => {
        this.companyList = res.data.rows.map((item) => {
          return { text: item.company_name, value: item.company_id };
        });
      });
    },
    loadFilter() {
      let filterData = {
        e: this.$route.query.e,
        m: "booth",
        currentPage: 1,
        perPage: 50,
      };

      let params = Object.keys(filterData)
        .map((key) => key + "=" + filterData[key])
        .join("&");

      Service.Filter.gets(params).then((res) => {
        this.filterList = res.data.rows;
      });
    },
    validateForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.submit();
        } else {
          // form have errors
        }
      });
    },
    submit() {
      let data = {
        e: this.$route.query.e,
        s: this.$route.query.s,
      };

      this.form.filter_slug = this.slug(
        this.form.m + " " + this.form.filter_name + " " + this.generateNumber()
      );

      this.form = { ...this.form, ...data };

      this.$vs.loading();
      Service.Booth.create(this.form)
        .then((res) => {
          if (res.success) {
            this.$vs.notify({
              title: "Success",
              text: "Process complete.",
              color: "success",
            });
            this.$router.push("/conferences/booths");
          }
          this.$vs.loading.close();
        })
        .catch((err) => {
          this.$vs.notify({
            title: "Oops!",
            text: "ERROR : " + err.error,
            color: "danger",
          });
          this.$vs.loading.close();
        });
    },
    slug(word) {
      let resp = word
        .toLowerCase() // LowerCase
        .replace(/\s+/g, "-") // space to -
        .replace(/&/g, `-and-`) // & to and
        .replace(/--/g, `-`); // -- to -
      return resp;
    },
    generateNumber: function () {
      return Math.floor(Math.random() * (99999999 - 10000000 + 1) + 10000000);
    },
  },
};
</script>